module.exports = __webpack_public_path__ + "static/media/groomingPagePreventiveIcon.06a8678d.png";